import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import { useEffect } from 'react'
import {
    ASSIGNEE_IDS_PARAM,
    CONFIDENCE_LEVELS_PARAM,
    MISMATCH_PARAM,
    REVIEW_STATUS_PARAM,
    SUBMISSION_SEARCH_PARAM,
} from '../../../../../../constants/query-params'

const useResetFilters = (questionId, testSetOnlyParam) => {
    const setQueryParam = useQueryParamSetter()

    // Reset all filters when switching to "all" questions
    useEffect(() => {
        if (questionId === 'all') {
            setQueryParam({
                [REVIEW_STATUS_PARAM]: undefined,
                [CONFIDENCE_LEVELS_PARAM]: undefined,
                [MISMATCH_PARAM]: undefined,
                [SUBMISSION_SEARCH_PARAM]: undefined,
                [ASSIGNEE_IDS_PARAM]: undefined,
            })
        }
    }, [questionId])

    // Reset mismatch and confidence filters when test set toggle changes
    useEffect(() => {
        setQueryParam({
            [MISMATCH_PARAM]: undefined,
            [CONFIDENCE_LEVELS_PARAM]: undefined,
        })
    }, [testSetOnlyParam])
}

export default useResetFilters
